import * as styles from "./DrawerClose.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Drawer as BaseDrawer } from "@base-ui/react/drawer";
import { Button } from "@frontend/components/atoms/Button";
import { Icon } from "@frontend/components/atoms/Icon";

import type { DrawerCloseProps } from "./Drawer.types";

export function DrawerClose({
  className,
  children,
  ...props
}: DrawerCloseProps): JSX.Element {
  return (
    <BaseDrawer.Close
      data-slot="drawer-close"
      className={clsx(styles.closeButton, className)}
      render={
        <Button variant="ghost" size="md" aria-label="Close">
          <Icon name="X" size="md" />
        </Button>
      }
      {...props}
    >
      {children}
    </BaseDrawer.Close>
  );
}
